module.exports = __webpack_public_path__ + "static/media/AKSIPS5.dc8ceea1.png";